import { render } from "./ProductCatalogPage.vue?vue&type=template&id=160d6180"
import script from "./ProductCatalogPage.vue?vue&type=script&lang=js"
export * from "./ProductCatalogPage.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__